import(/* webpackMode: "eager", webpackExports: ["LiveRatesInteractive"] */ "/home/ubuntu/download/696e0a131beda80014d10e92/blockp2p/src/app/live-rates-dashboard/components/LiveRatesInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696e0a131beda80014d10e92/blockp2p/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696e0a131beda80014d10e92/blockp2p/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696e0a131beda80014d10e92/blockp2p/src/components/common/TrustBadgeCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696e0a131beda80014d10e92/blockp2p/src/components/common/WhatsAppFloatingButton.tsx");
